export interface ClientReassignmentFormShape {
  reassignedTo: string;
}

export enum ClientReassignmentModalCloseReason {
  CLOSE = 'CLOSE',
  COMPLETE = 'COMPLETE',
}
